<template>

  <!--<span-->
  <!--id="tableSelection"-->
  <!--class="tableSelection">-->
  <!--<v-btn-->
  <!--:class="{ secondary: overdueSelection === 'pastDue'}"-->
  <!--selection="pastDue"-->
  <!--color="#3357A0"-->
  <!--@click="$emit('filterFactorings','pastDue')">{{ 'krita.claims.pastduedate' | translate }}</v-btn>-->
  <!--<v-btn-->
  <!--:class="{ secondary: overdueSelection === 'soon'}"-->
  <!--selection="soon"-->
  <!--color="#3357A0"-->
  <!--@click="$emit('filterFactorings','soon')">{{ 'krita.claims.soon' | translate }}</v-btn>-->
  <!--<v-btn-->
  <!--:class="{ secondary: overdueSelection === 'all'}"-->
  <!--selection="all"-->
  <!--color="#3357A0"-->
  <!--@click="$emit('filterFactorings','all')">{{ 'krita.claims.all' | translate }}</v-btn>-->
  <!--</span>-->
  <span
    id="Group-claims"
  >
    <span class="heading-6">
      <span
        id="selectionCount"
        style="margin-left: 10px">{{ getCountOverdueFactorings() }}</span>
      <span style="margin-left: 10px"> {{ 'krita.claims.additems' | translate }}</span>
      <span
        id="selectionAmount"
        style="margin-left: 10px">{{ getAmountOverdueFactorings() | amount }}</span>
    </span>
    <module-button
      :disabled="repayBtnDisable"
      :values="repayBtn"
      :loading="creatingRepayment"
      :dialog="creatingRepayment"
      @confirmClick="$emit('createRepayment')"/>
    <span
      class="pseudolink"
      style="margin-left: 10px"
      @click="$emit('clearState', 'overdue')">{{ 'krita.claims.clear' | translate }}</span>
  </span>

</template>

<script>
import ModuleButton from '../controllers/ModuleButton.vue';
    export default {
        name: "OverdueFactoringsControllers",
        components: {ModuleButton},
        props: ['creatingRepayment','overdueFactorings','overdueSelection', 'createRepaymentDialog'],
        computed: {
            repayBtn ()
            {
                let text = this.$t('krita.claims.repaymodal.part1') +' ' + this.getCountOverdueFactorings() + ' ' + this.$t('krita.claims.repaymodal.part2') +' ' + this.amountOverdueFactorings + '\n' +
                    '\n' + ' ' +
                    this.$t('krita.claims.repaymodal.part3');
                let repayBtnClient = {
                    icon:'',
                    headline: this.$t('krita.claims.repayfactoring'),
                    confirmBtnText: this.$t('krita.claims.createrepayment'),
                    openBtnText: this.$t('krita.claims.repay'),
                    text: text,
                    openBtnColor:'#16DB94',
                    confirmBtnColor:'#16DB94'
                };
                return repayBtnClient;
            },
            repayBtnDisable ()
            {
                if (this.getCountOverdueFactorings() === 0)
                {
                    return true;
                }
                return false;
            },
            amountOverdueFactorings()
            {
                let amountOverdue = this.getAmountOverdueFactorings();
                return [Math.ceil(amountOverdue).toLocaleString('de-DE'), ' kr.'].join('').replace(',','.');
            },
        },
        methods: {
            getCountOverdueFactorings()
            {
                let self = this;

                let count = 0;

                for (let factoring of self.overdueFactorings)
                {
                    if (factoring.added)
                    {
                        count++;
                    }
                }
                return count;
            },
            getAmountOverdueFactorings()
            {
                let self = this;

                let amount = 0;
                for (let factoring of self.overdueFactorings)
                {
                    if (factoring.added)
                    {
                        amount = amount + factoring.LeftToPay;
                    }
                }
                return amount;
            },
        }
    }
</script>

<style lang="css" scoped>
    .pseudolink {
        color:blue;
        cursor:pointer;
    }
</style>
